"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createForm = void 0;
const FormItem_1 = require("./FormItem");
const withTypedName_1 = require("./withTypedName");
const FormBooleanItem_1 = require("./FormItem/FormItemTypes/FormBooleanItem");
const createForm = () => {
    return {
        TextItem: (0, withTypedName_1.withTypedName)(FormItem_1.FormTextItem),
        DateItem: (0, withTypedName_1.withTypedName)(FormItem_1.FormDateItem),
        DateTimeItem: (0, withTypedName_1.withTypedName)(FormItem_1.FormDateTimeItem),
        NumberItem: (0, withTypedName_1.withTypedName)(FormItem_1.FormNumberItem),
        TextareaItem: (0, withTypedName_1.withTypedName)(FormItem_1.FormTextareaItem),
        EnumItem: (0, withTypedName_1.withTypedName)(FormItem_1.FormEnumItem),
        BooleanItem: (0, withTypedName_1.withTypedName)(FormBooleanItem_1.FormBooleanItem),
    };
};
exports.createForm = createForm;
